import { render, staticRenderFns } from "./CallbackQQ.vue?vue&type=template&id=1c8a42ef&scoped=true"
import script from "./CallbackQQ.vue?vue&type=script&lang=js"
export * from "./CallbackQQ.vue?vue&type=script&lang=js"
import style0 from "./CallbackQQ.vue?vue&type=style&index=0&id=1c8a42ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8a42ef",
  null
  
)

export default component.exports